<template>
    <div class="row m-2">
        <div class="col-12">
            <div class="row">
                <div class="col-12">
                    <p class="fs-12">Yang bertanda tangan di bawah ini, menerangkan bahwa:</p>
                </div>
                <div v-if="PasienInformation && Object.keys(PasienInformation).length > 0" class="col-12">
                    <table class="table table-borderless">
                        <tr>
                            <td class="text-capitalize pl-0 fs-12" style="width: 15%">nama</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div class="fs-12">{{ PasienName }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0 fs-12" style="width: 15%">umur</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div class="fs-12">{{ PasienAge }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0 fs-12" style="width: 15%">jenis kelamin</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div class="fs-12">{{ ParseJenisKelaminSurat(PasienSex) }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0 fs-12" style="width: 15%">alamat</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div class="fs-12">{{ PasienAddress }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0 fs-12" style="width: 15%">pekerjaan</td>
                            <td>
                                <div class="d-flex align-items-center">
                                    <span class="mr-4">:</span>
                                    <template v-if="CurrentlyPrintingLetter">
                                        <span class="fs-12">
                                            {{ IsLainLainSelected ? CustomPekerjaan : SelectedPekerjaan }}
                                        </span>
                                    </template>
                                    <template v-else>
                                        <validation-provider rules="required" v-slot="{ errors }" tag="div" class="w-100">
                                            <div class="row">
                                                <div class="col-4">
                                                    <VMultiSelect v-model="SelectedPekerjaan" :options="PekerjaanSurat"
                                                        :show-labels="false" />
                                                    <span class="text-danger">{{ errors[0] }}</span>
                                                </div>
                                            </div>
                                        </validation-provider>
                                    </template>
                                </div>
                            </td>
                        </tr>
                        <template v-if="!CurrentlyPrintingLetter">
                            <tr v-if="IsLainLainSelected">
                                <td></td>
                                <td>
                                    <div class="d-flex align-items-center">
                                        <span class="mr-4">:</span>
                                        <validation-provider rules="required" v-slot="{ errors }" tag="div" class="w-100">
                                            <div class="row">
                                                <div class="col-4">
                                                    <input v-model="CustomPekerjaan" type="text" class="form-control" />
                                                    <span class="text-danger">{{ errors[0] }}</span>
                                                </div>
                                            </div>
                                        </validation-provider>
                                    </div>
                                </td>
                            </tr>
                        </template>
                        <tr>
                            <td class="text-capitalize pl-0 fs-12" style="width: 15%">diagnosa</td>
                            <td>
                                <div class="d-flex align-items-center">
                                    <span class="mr-4">:</span>
                                    <template v-if="CurrentlyPrintingLetter">
                                        <span class="fs-12">
                                            {{ PrintModeSelectedDiagnosa }}
                                        </span>
                                    </template>
                                    <template v-else>
                                        <validation-provider rules="required" v-slot="{ errors }" class="w-100">
                                            <div class="row">
                                                <div class="col-4">
                                                    <VMultiSelect :value="SelectedDiagnosa" :options="ListDiagnosa"
                                                        @select="DiagnosaSelection" :custom-label="ListDiagnosaLabel"
                                                        @search-change="GetListDiagnosa" :multiple="true"
                                                        @remove="RemoveDiagnosa" />
                                                    <span class="text-danger">{{ errors[0] }}</span>
                                                </div>
                                            </div>
                                        </validation-provider>
                                    </template>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>
                                <div class="d-flex align-items-center">
                                    <span class="mr-4">:</span>
                                    <template v-if="CurrentlyPrintingLetter">
                                        <span class="fs-12">
                                            {{ RemarksDiagnosa }}
                                        </span>
                                    </template>
                                    <template v-else>
                                        <validation-provider v-slot="{ errors }" tag="div" class="w-100">
                                            <div class="row">
                                                <div class="col-4">
                                                    <textarea v-model="RemarksDiagnosa" type="text"
                                                        class="w-100 form-control"></textarea>
                                                    <span class="text-danger">{{ errors[0] }}</span>
                                                </div>
                                            </div>
                                        </validation-provider>
                                    </template>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="col-12 mb-2">
                    <p style="margin-bottom: 8px"  class="fs-12">Oleh karena
                        <span class="text-uppercase font-weight-bold">sakit</span>,
                        perlu diberikan
                        <span class="text-uppercase font-weight-bold fs-12">istirahat</span>
                    </p>
                    <p class="d-flex align-items-center">
                        <span class="mr-2 fs-12">selama</span>

                        <template v-if="CurrentlyPrintingLetter">
                            <span class="fs-12">
                                {{ SickPeriode }}
                            </span>
                        </template>
                        <template v-else>
                            <validation-provider rules="required" v-slot="{ errors }" tag="div" class="mr-2"
                                style="width: 10%">
                                <input v-model="SickPeriode" type="text" class="form-control" />
                                <span class="text-danger">{{ errors[0] }}</span>
                            </validation-provider>
                        </template>

                        <span class="mx-2 fs-12">hari terhitung mulai tanggal</span>

                        <template v-if="CurrentlyPrintingLetter">
                            <span class="fs-12">
                                {{ StartSickPeriode }}
                            </span>
                        </template>
                        <template v-else>
                            <validation-provider rules="required" v-slot="{ errors }" tag="div">
                                <div class="d-flex flex-column">
                                    <date-picker :value-type="SuratDatePickerFormat()" v-model="StartSickPeriode"
                                        :format="SuratDatePickerFormat()" type="date" :clearable="false"
                                        :disabled-date="ProxyDatePickerDisabledNextDate"
                                        input-class="form-control"></date-picker>
                                    <span class="text-danger">{{ errors[0] }}</span>
                                </div>
                            </validation-provider>
                        </template>

                        <span class="mx-2">s/d</span>

                        <template v-if="CurrentlyPrintingLetter">
                            <span class="fs-12">
                                {{ EndSickPeriode }}
                            </span>
                        </template>
                        <template v-else>
                            <validation-provider rules="required" v-slot="{ errors }" tag="div">
                                <div class="d-flex flex-column">
                                    <date-picker :value-type="SuratDatePickerFormat()" v-model="EndSickPeriode"
                                        :format="SuratDatePickerFormat()" type="date" :clearable="false"
                                        :disabled-date="ProxyDatePickerDisabledPreviousDate"
                                        input-class="form-control"></date-picker>
                                    <span class="text-danger">{{ errors[0] }}</span>
                                </div>
                            </validation-provider>
                        </template>
                    </p>
                </div>
                <div class="col-12">
                    <p class="mb-4 fs-12">
                        Demikian surat keterangan sakit ini dibuat dengan sebenarnya dan untuk dipergunakan semestinya.
                    </p>
                </div>

            </div>
        </div>


        <div class="col-12 mt-3">
            <div class="row">
                <div class="col-12">
                    <p class="fs-12">{{ KlinikInformation.KlinikCity }}, {{ SuratDate() }}</p>
                </div>
                <div class="col-12 mt-4 pt-4">
                    <p class="mb-1 fs-12">{{ DokterInformation.DokterName }}</p>
                    <p class="fs-12">{{ DokterInformation.DokterSIP }}</p>
                </div>
            </div>
        </div>

        <div class="col-12">
            <SuratPenunjangFormBaseDigitalSign :increaseFont="true" />
        </div>
    </div>
</template>

<script>
import "vue2-datepicker/index.css";
import { mapState, mapGetters, mapMutations } from 'vuex'
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', {
    ...required,
    message: 'This field is required'
});

import { SuratDate, SuratDatePickerFormat, SuratDatePickerDisabledPreviousDate, SuratDatePickerDisabledNextDate } from '../../Helpers/DateSurat.js'
import { ParseJenisKelaminSurat } from '../../Helpers/ParseJenisKelaminSurat.js'
import { OnlyNumericCommaAndDotInputOnKeypress } from '../../Helpers/InputEvent.js'
import { PekerjaanCustom } from '../../Helpers/PekerjaanSurat.js'

export default {
    name: 'SuratSakitBody',
    components: {
        DatePicker: () => import('vue2-datepicker'),
        VMultiSelect: () => import('vue-multiselect'),
        SuratPenunjangFormBaseDigitalSign: () => import('../Base/SuratPenunjangFormBaseDigitalSign.vue')
    },
    data() {
        return {
            PasienName: null,
            PasienAge: null,
            PasienSex: null,
            PasienAddress: null,
            SelectedPekerjaan: null,
            CustomPekerjaan: null,
            SelectedDiagnosa: [],
            RemarksDiagnosa: null,
            SickPeriode: null,
            StartSickPeriode: null,
            EndSickPeriode: null,
            ListDiagnosa: [],
        }
    },
    watch: {
        PasienInformation: {
            handler: function (val) {
                if (val && Object.keys(val).length > 0 && !this.LetterID) {
                    Object.keys(val).map(key => {
                        if (this[key] !== undefined) {
                            let tmpVal = val[key]
                            this.$set(this, key, tmpVal)
                        }
                    })
                }
            },
            deep: true,
            immediate: true
        },
        RekamMedisPostData: {
            handler: function (val) {
                if (!this.LetterID) {
                    if (val.kode_penyakit_primary && val.kode_penyakit_primary.kode) {
                        this.SelectedDiagnosa.push(val.kode_penyakit_primary);
                    }
                    if (val.kode_penyakit && val.kode_penyakit.length > 0) {
                        val.kode_penyakit.forEach((item) => {
                            this.SelectedDiagnosa.push(item);
                        });
                    }
                    if (val.odontogram_icdx && val.odontogram_icdx.length > 0) {
                        val.odontogram_icdx.forEach((item) => {
                            item.forEach(v => {
                                this.SelectedDiagnosa.push(v);
                            });
                        });
                    }
                }
            },
            deep: true,
            immediate: true
        }
    },
    async mounted() {
        if (!this.LetterID) {
            await this.GetListDiagnosa()
        }

        this.$nextTick(() => {
            this.$emit('ComponentMounted')
        })
    },
    computed: {
        ...mapState({ RekamMedisPostData: state => state.rekamMedis.postData }),
        ...mapState('SuratPenunjangStore', ['CurrentlyPrintingLetter', 'PasienInformation', 'KlinikInformation', 'DokterInformation', 'TransKlinikIDFromPembayaran', 'LetterID', 'AtPembayaranPage', 'LetterNumber']),
        ...mapGetters('SuratPenunjangStore', ['BASE_API_URL', 'API_URL', 'PekerjaanSurat', 'TransKlinikID']),
        IsLainLainSelected() {
            return this.SelectedPekerjaan === 'Lain-lain'
        },
        SuratSakitEndpoint() {
            return `${this.API_URL}/surat-sakit`
        },
        PayloadBackend() {
            return {
                namaPasien: this.PasienName,
                umurPasien: this.PasienAge,
                jenisKelaminPasien: this.PasienSex,
                alamatPasien: this.PasienAddress,
                pekerjaanPasien: this.IsLainLainSelected ? this.CustomPekerjaan : this.SelectedPekerjaan,
                diagnosaPasien: this.SelectedDiagnosa && this.SelectedDiagnosa.length > 0 ? this.SelectedDiagnosa.map(val => val.kode).join(',') : null,
                deskripsiDiagnosaPasien: this.RemarksDiagnosa,
                totalHariPasien: this.SickPeriode,
                startDatePasien: this.StartSickPeriode,
                endDatePasien: this.EndSickPeriode,
                kotaSurat: this.KlinikInformation.KlinikCity,
                tanggalSurat: this.SuratDate(),
                transKlinikId: !this.AtPembayaranPage ? this.TransKlinikID : this.TransKlinikIDFromPembayaran,
                nomorSurat: this.LetterNumber
            }
        },
        PrintModeSelectedDiagnosa() {
            if (this.SelectedDiagnosa) {
                return this.SelectedDiagnosa.map(val => `${val.kode} - ${val.description}`).join('; ')
            } else {
                return null
            }
        }
    },
    methods: {
        ...mapMutations(['SET_LOADING']),
        ...mapMutations('SuratPenunjangStore', ['SetLetterNumber']),
        PekerjaanCustom,
        SuratDatePickerFormat,
        ParseJenisKelaminSurat,
        SuratDate,
        OnlyNumericCommaAndDotInputOnKeypress,
        ProxyDatePickerDisabledNextDate(DateValue, CurrentDateValue) {
            return SuratDatePickerDisabledNextDate(this.EndSickPeriode, DateValue)
        },
        ProxyDatePickerDisabledPreviousDate(DateValue, CurrentDateValue) {
            return SuratDatePickerDisabledPreviousDate(this.StartSickPeriode, DateValue)
        },
        ListDiagnosaLabel({ kode, description }) {
            return `${kode} - ${description}`
        },
        DiagnosaSelection(val) {
            const tmp = [...(this.SelectedDiagnosa || []), val];
            this.$set(this, 'SelectedDiagnosa', tmp);
        },
        RemoveDiagnosa(val) {
            const tmp = this.SelectedDiagnosa.filter(item => item.kode !== val.kode)
            this.$set(this, 'SelectedDiagnosa', tmp)
        },
        async GetListDiagnosa(Value = '', ReturnData = false) {
            const { data } = await this.$axios.get(`${this.BASE_API_URL}/kode_penyakit?name=${Value}`)

            const { kode_penyakit } = data.data

            if (ReturnData) {
                return kode_penyakit.data
            } else {
                this.ListDiagnosa = kode_penyakit.data
            }
        },
        async GetData() {
            this.SET_LOADING(true)
            this.$nextTick(async () => {
                const { data } = await this.$axios.get(`${this.SuratSakitEndpoint}/${this.LetterID}`);

                this.PasienName = data.nama_pasien
                this.PasienAge = data.umur_pasien
                this.PasienSex = data.jenis_kelamin_pasien
                this.PasienAddress = data.alamat_pasien
                this.SelectedPekerjaan = this.PekerjaanCustom(data.pekerjaan_pasien)
                this.CustomPekerjaan = this.SelectedPekerjaan === 'Lain-lain' ? data.pekerjaan_pasien : null

                this.RemarksDiagnosa = data.deskripsi_diagnosa_pasien
                this.SickPeriode = data.total_hari_pasien
                this.StartSickPeriode = data.start_date_pasien
                this.EndSickPeriode = data.end_date_pasien

                this.SelectedDiagnosa = []

                data.diagnosa_pasien.split(',').map(async (val) => {
                    const data = await this.GetListDiagnosa(val, true)
                    this.ListDiagnosa = [...this.ListDiagnosa, ...data]
                    this.SelectedDiagnosa = [...this.SelectedDiagnosa, this.ListDiagnosa.find(item => item.kode === val)]
                })

                this.SetLetterNumber(data.nomor_surat)

                this.$nextTick(() => {
                    this.SET_LOADING(false)
                })
            })

        },
        async UpdateData() {
            const { data } = await this.$axios.put(`${this.SuratSakitEndpoint}/${this.LetterID}`, this.PayloadBackend);
            return data;
        },
        async SaveData() {
            const { data } = await this.$axios.post(`${this.SuratSakitEndpoint}/create`, this.PayloadBackend);
            return data;
        },
    }
}
</script>

<style lang="scss">
.surat-sakit {
    .table {
        td {
            padding-top: 0;
            padding-bottom: 14px;
        }
    }
}

.fs-12 {
    font-size: 16pt !important;
}
</style>